export default __webpack_public_path__ + "static/media/Refined Elixir of Mystical Excellence.6f5b7e71.jpg";